<h1 matDialogTitle class="text-capitalize">
    {{ indicator.alias || indicator.name }}
</h1>


<mat-dialog-content>
    <form class="parameter-container display-flex-column" [formGroup]="paramsForm" *ngIf="paramsForm">
        <div class="parameter margin-bottom" *ngFor="let indicator of params">
            <ng-container *ngIf="indicator.isSelect">
                <mat-form-field class="full-width condensed-select-field" appearance="outline" color="accent" hideRequiredMarker>
                    <mat-label class="padding-left">
                        {{ indicator.displayName }}
                    </mat-label>

                    <mat-select [formControlName]="indicator.name">
                        <mat-option [value]="option" *ngFor="let option of indicator.selectOptions">
                            {{ option }}
                        </mat-option>
                    </mat-select>

                    <mat-error *ngIf="paramsForm.get(indicator.name).hasError('required')">
                        {{ indicator.displayName }} is required
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <ng-container *ngIf="!indicator.isSelect">
                <mat-form-field class="full-width condensed-select-field margin-8-bottom" appearance="outline" color="accent">
                    <mat-label class="padding-left">{{ indicator.displayName }}</mat-label>
                    <input matInput [formControlName]="indicator.name" appNumberOnly 
                    [min]="MIN_ABSOLUTE_VALUE"
                    [decimal]="indicator.displayType === IndicatorDisplayType.FLOAT">

                    <mat-error *ngIf="paramsForm.get(indicator.name).hasError('required')">
                        {{ indicator.displayName }} is required
                    </mat-error>
                    <mat-error *ngIf="paramsForm.get(indicator.name).hasError('min')">
                        {{ indicator.displayName }} must be greater than {{ indicator.min_value }}
                    </mat-error>
                    <mat-error *ngIf="paramsForm.get(indicator.name).hasError('max')">
                        {{ indicator.displayName }} must be less than {{ indicator.max_value }}
                    </mat-error>
                </mat-form-field>
            </ng-container>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions class="text-right flex-centered-container">
    <button mat-flat-button color="warn" (click)="closeDialog()">Cancel</button>
    <button mat-flat-button color="accent" (click)="saveDialog()">Save</button>
</mat-dialog-actions>